import "./App.scss";
import React from "react";
import Navigation from "./Pages/Navigation";

function App() {
  return (
    <div className="App">
      <Navigation />
    </div>
  );
}

export default App;
